var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear-apple-music-circle-icon",
    x1: 40,
    y1: 79.6961,
    x2: 40,
    y2: 1.72435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA233B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB5C74"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear-apple-music-circle-icon)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5557 12.2227C56.3668 12.2449 54.6446 12.5449 54.4334 12.5893L30.6557 17.3893H30.6445C30.0223 17.5227 29.5334 17.7449 29.1668 18.056C28.7112 18.4338 28.4668 18.9782 28.3668 19.6004C28.3445 19.7338 28.3112 20.0004 28.3112 20.4004C28.3112 20.4004 28.3112 44.6893 28.3112 50.156C28.3112 50.856 28.2557 51.5227 27.789 52.1004C27.3223 52.6782 26.7334 52.8449 26.0557 52.9893C25.5334 53.0893 25.0223 53.2005 24.5001 53.3004C22.5334 53.7005 21.2557 53.9671 20.1001 54.4116C18.989 54.8449 18.1668 55.3893 17.5001 56.0782C16.189 57.4449 15.6557 59.3116 15.8445 61.056C16.0001 62.5449 16.6668 63.9671 17.8223 65.0116C18.6001 65.7227 19.5668 66.2671 20.7112 66.4893C21.9001 66.7227 23.1557 66.6449 25.0001 66.2671C25.9779 66.0671 26.9001 65.756 27.7779 65.2449C28.6445 64.7338 29.389 64.056 29.9668 63.2227C30.5445 62.3893 30.9223 61.4671 31.1334 60.4782C31.3445 59.4671 31.4001 58.5449 31.4001 57.5338V31.7338C31.4001 30.356 31.789 29.9893 32.9112 29.7116C32.9112 29.7116 52.6779 25.7227 53.6001 25.5449C54.889 25.3004 55.489 25.6671 55.489 27.0116V44.6338C55.489 45.3338 55.4779 46.0338 55.0112 46.6116C54.5445 47.1893 53.9557 47.356 53.2779 47.5004C52.7557 47.6004 52.2445 47.7116 51.7223 47.8116C49.7557 48.2116 48.4779 48.4782 47.3223 48.9227C46.2112 49.356 45.389 49.9004 44.7223 50.5893C43.4112 51.956 42.8334 53.8227 43.0223 55.5671C43.1779 57.056 43.889 58.4782 45.0445 59.5227C45.8223 60.2338 46.789 60.756 47.9334 60.9893C49.1223 61.2227 50.3779 61.1449 52.2223 60.7671C53.2001 60.5671 54.1223 60.2782 55.0001 59.756C55.8668 59.2449 56.6112 58.5671 57.189 57.7338C57.7668 56.9004 58.1445 55.9782 58.3557 54.9893C58.5668 53.9782 58.5779 53.056 58.5779 52.0449V14.3227C58.5668 12.956 57.8445 12.1116 56.5557 12.2227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleMusic);
export default __webpack_public_path__ + "static/media/apple-music.0a3c8c349215cc8994bff5a0ec54a1bd.svg";
export { ForwardRef as ReactComponent };